import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';

const Features = () => {
  const features = [
    {
      icon: "id-card",
      title: "Personal & Business Cards",
      description: "Create stunning digital cards for both personal and professional use with fully customizable templates that match your brand and style.",
      link: "/personal-card"
    },
    {
      icon: "share-alt",
      title: "Instant Sharing",
      description: "Share your digital cards via QR code, text, email, or with a premium NFC tap that makes networking effortless and memorable.",
      link: "/personal-card"
    },
    {
      icon: "layer-group",
      title: "Contact Collections",
      description: "Organize contacts into collections for easy access and management. Sync with your phone's contacts for seamless integration.",
      link: "/personal-card"
    },
    {
      icon: "sync-alt",
      title: "Real-time Updates",
      description: "Update your information once, and all your shared cards update automatically. No more outdated contact details or reprinting cards.",
      link: "/personal-card"
    },
    {
      icon: "chart-line",
      title: "Analytics Dashboard",
      description: "Track views and engagement with your digital cards. Gain insights into your networking effectiveness with detailed analytics.",
      link: "/personal-card"
    },
    {
      icon: "palette",
      title: "Custom Design Options",
      description: "Choose from a variety of templates, colors, and backgrounds to create a card that perfectly represents your personal or company brand.",
      link: "/personal-card"
    }
  ];

  return (
    <section id="features" className="py-24 bg-white relative">
      <div className="absolute inset-0 bg-features-bg"></div>
      
      <div className="container mx-auto px-6 relative z-10">
        <div className="text-center max-w-3xl mx-auto mb-20">
          <div className="badge badge-blue inline-flex mb-4">
            <FontAwesomeIcon icon="rocket" />
            <span>Powerful Features</span>
          </div>
          
          <h2 className="section-title">
            Everything You Need for <span className="text-gradient-blue-pink">Modern Networking</span>
          </h2>
          
          <p className="section-description">
            AM CARDMATE provides all the tools you need to create stunning digital cards, share them effortlessly, and manage your professional connections.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
          {features.map((feature, index) => (
            <div 
              key={index} 
              className="card p-12 relative overflow-hidden hover:shadow-lg hover:-translate-y-2 transition-all duration-300"
            >
              <div className="absolute top-0 left-0 w-1 h-0 bg-gradient-blue transition-all duration-500 ease-bounce-in group-hover:h-full"></div>
              
              <div className="relative inline-block mb-8">
                <div className="w-20 h-20 rounded-lg bg-blue-100/50 flex items-center justify-center text-4xl text-primary-blue transition-all duration-300 group-hover:bg-gradient-blue group-hover:text-white group-hover:shadow-blue">
                  <FontAwesomeIcon icon={feature.icon} />
                </div>
                <div className="absolute -top-1 -left-1 w-[90px] h-[90px] rounded-lg bg-gradient-to-r from-blue-200/20 to-purple-200/20 opacity-0 scale-90 transition-all duration-300 -z-10 group-hover:opacity-100 group-hover:scale-100"></div>
              </div>
              
              <h3 className="text-h4 text-dark mb-4">{feature.title}</h3>
              
              <p className="text-body text-gray mb-6">
                {feature.description}
              </p>
              
              <Link 
                to={feature.link} 
                className="inline-flex items-center gap-2 text-btn text-primary-blue hover:gap-3 transition-all duration-300"
              >
                Learn more <FontAwesomeIcon icon="arrow-right" />
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;